'use client';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages, onPageChange }: PaginationProps) {
  const pages = Array.from({ length: Math.min(totalPages, 8) }, (_, i) => i + 1);

  return (
    <div className="flex items-center gap-1 mt-8 justify-center">
      <button
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
        className="w-9 h-9 border border-[#D4D4D4] flex items-center justify-center font-['IBM_Plex_Sans',system-ui,sans-serif] text-[13px] text-[#2D2D2D] hover:bg-[#F5F4F0] disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        aria-label="Previous page"
      >
        ←
      </button>
      {pages.map((page) => (
        <button
          key={page}
          onClick={() => onPageChange(page)}
          className={`w-9 h-9 border flex items-center justify-center font-['IBM_Plex_Sans',system-ui,sans-serif] text-[13px] transition-colors ${
            currentPage === page
              ? 'bg-[#1A1A1A] text-white border-[#1A1A1A]'
              : 'border-[#D4D4D4] text-[#2D2D2D] hover:bg-[#F5F4F0]'
          }`}
        >
          {page}
        </button>
      ))}
      {totalPages > 8 && <span className="px-2 text-[#6B6B6B] font-['IBM_Plex_Sans',system-ui,sans-serif] text-[13px]">...</span>}
      <button
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
        className="w-9 h-9 border border-[#D4D4D4] flex items-center justify-center font-['IBM_Plex_Sans',system-ui,sans-serif] text-[13px] text-[#2D2D2D] hover:bg-[#F5F4F0] disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        aria-label="Next page"
      >
        →
      </button>
    </div>
  );
}
